import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { AUTO_ADJUSTMENT_RULES_QUERY_KEY } from '../constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AutoAdjustmentRuleService } from '../services';

export const useAutoAdjustmentRuleDelete = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('auto-adjustment-rules');
  return useMutation(() => AutoAdjustmentRuleService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [AUTO_ADJUSTMENT_RULES_QUERY_KEY] }).then();
    },
  });
};
